import createQueryString from './createQueryString';

export default (path = '', query = {}) => {
  const formattedQuery = createQueryString(query);
  const formattedPath = path[path.length - 1] === '/' ? path : `${path}/`;

  return `${formattedPath}?${formattedQuery}`;
};
